import { createFileRoute } from "@tanstack/react-router";
import { PlaySessionPage } from "@/features/game-resources";
import { loadPlaySession } from "@/features/game-resources/records";
import {
  resourceHead,
  resourceSearchSchema,
} from "@/features/game-resources/navigation";

export const Route = createFileRoute(
  "/_site/unlisted/$coworld_/play-sessions/$sessionId",
)({
  validateSearch: (search) => resourceSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ params, deps, abortController }) =>
    loadPlaySession({
      data: {
        resourceId: params.sessionId,
        game: { slug: params.coworld, catalog_status: "unlisted" },
        search: deps.search,
      },
      signal: abortController.signal,
    }),
  head: () => resourceHead("Play session"),
  component: Page,
});

function Page() {
  return <PlaySessionPage data={Route.useLoaderData()} />;
}
